export const AGENDA_SWATCHES = [
  '#1976d2',
  '#2e7d32',
  '#ed6c02',
  '#9c27b0',
  '#d32f2f',
  '#0288d1',
  '#5d4037',
  '#455a64',
  '#f9a825',
  '#00796b',
  '#c2185b',
  '#303f9f',
  '#00897b',
  '#6a1b9a',
  '#546e7a',
  '#e65100',
];

export function contrastTextForBg(hex) {
  if (!hex || typeof hex !== 'string') return '#ffffff';
  let h = hex.trim();
  if (h[0] === '#') h = h.slice(1);
  if (h.length === 3) {
    h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  }
  if (h.length !== 6) return '#ffffff';
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) return '#ffffff';
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 186 ? '#000000' : '#ffffff';
}

export function loadAgendaColorsMap(userId) {
  if (userId == null) return {};
  try {
    const raw = localStorage.getItem(`alodesk.agendaColors.${userId}`);
    if (!raw) return {};
    const o = JSON.parse(raw);
    return typeof o === 'object' && o && !Array.isArray(o) ? o : {};
  } catch {
    return {};
  }
}

export function saveAgendaColorsMap(userId, map) {
  if (userId == null) return;
  try {
    localStorage.setItem(`alodesk.agendaColors.${userId}`, JSON.stringify(map));
  } catch {}
}

export function pickUnusedSwatch(usedValues) {
  const used = new Set(usedValues.filter(Boolean));
  const found = AGENDA_SWATCHES.find((c) => !used.has(c));
  return found || AGENDA_SWATCHES[0];
}

export function loadAgendaOverlayUserIds(userId) {
  if (userId == null) return [];
  try {
    const raw = localStorage.getItem(`alodesk.agendaOverlayUserIds.${userId}`);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr.map((x) => Number(x)).filter((n) => Number.isFinite(n) && n > 0);
  } catch {
    return [];
  }
}

export function saveAgendaOverlayUserIds(userId, ids) {
  if (userId == null) return;
  try {
    localStorage.setItem(`alodesk.agendaOverlayUserIds.${userId}`, JSON.stringify(ids));
  } catch {}
}
